import { render, staticRenderFns } from "./PolygonMap.vue?vue&type=template&id=89140ae6"
import script from "./PolygonMap.vue?vue&type=script&lang=js"
export * from "./PolygonMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports